import { tv, type VariantProps } from 'tailwind-variants'

export const placeholderMedia = tv({
  base: '',
  variants: {
    size: {
      'avatar-sm': 'h-10 w-10',
      'avatar-md': 'h-12 w-12',
      'avatar-lg': 'h-14 w-14',
    },
    radius: {
      none: 'rounded-none',
      sm: 'rounded-lg',
      md: 'rounded-xl',
      lg: 'rounded-2xl',
      full: 'rounded-full',
    },
    contrast: {
      dark: 'bg-default-bg-loading-dark',
      light: 'bg-default-bg-loading',
    },
  },
  defaultVariants: {
    size: 'avatar-md',
    radius: 'full',
    contrast: 'dark',
  },
})

export type TPlaceholderMediaVariantProps = VariantProps<typeof placeholderMedia>
